import { Injectable } from "@angular/core";
import { TPApplicationRole } from "../api-generated/model/tPApplicationRole";
import BaseService from "./base.service";

@Injectable({
  providedIn: "root",
})
export default class LocalApplicationRoleService extends BaseService<TPApplicationRole> {}
